export class ListSqlEnginesFilterConditions {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "IdFilters",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "StringFilters",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "SqlEngineStatusFilters",
            "format": ""
        },
        {
            "name": "credentialsProfileId",
            "baseName": "credentialsProfileId",
            "type": "IdFilters",
            "format": ""
        },
        {
            "name": "useSpot",
            "baseName": "useSpot",
            "type": "BooleanFilters",
            "format": ""
        },
        {
            "name": "autoscaling",
            "baseName": "autoscaling",
            "type": "BooleanFilters",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListSqlEnginesFilterConditions.attributeTypeMap;
    }
    constructor() {
    }
}
